(function () {
  'use strict';

  // ── Event name registry ───────────────────────────────────────────────────────
  var EVENTS = Object.freeze({
    CART_ADD:          'laki:cart:add',
    CART_UPDATE:       'laki:cart:update',
    CART_DRAWER_OPEN:  'laki:cart:drawer:open',
    CART_DRAWER_CLOSE: 'laki:cart:drawer:close',
    VARIANT_CHANGE:    'laki:variant:change',
    SECTION_RENDERED:  'laki:section:rendered',
    SEARCH_OPEN:       'laki:search:open',
    SEARCH_CLOSE:      'laki:search:close',
    DRAWER_OPEN:       'laki:drawer:open',
    DRAWER_CLOSE:      'laki:drawer:close'
  });

  // ── Pub/sub bus ───────────────────────────────────────────────────────────────
  var listeners = Object.create(null);

  var LakiEvents = {
    EVENTS: EVENTS,

    on: function (event, callback) {
      if (!listeners[event]) listeners[event] = [];
      listeners[event].push(callback);
      var self = this;
      return function () { self.off(event, callback); };
    },

    off: function (event, callback) {
      if (!listeners[event]) return;
      listeners[event] = listeners[event].filter(function (cb) { return cb !== callback; });
    },

    emit: function (event, data) {
      if (!listeners[event]) return;
      listeners[event].forEach(function (cb) {
        try { cb(data); } catch (_) {}
      });
    },

    once: function (event, callback) {
      var unsub = this.on(event, function (data) {
        callback(data);
        unsub();
      });
      return unsub;
    }
  };

  // ── Component registry ────────────────────────────────────────────────────────
  var registry = new Map();

  var LakiComponents = {
    // Register a named component factory
    define: function (name, factory) {
      registry.set(name, factory);
    },

    // Mount a single element — idempotent
    mount: function (name, el, options) {
      if (!el || !el.isConnected) return;
      if (!el._laki) el._laki = new Set();
      if (el._laki.has(name)) return;
      var factory = registry.get(name);
      if (!factory) return;
      factory(el, options);
      el._laki.add(name);
    },

    // Mount all matching elements immediately
    mountAll: function (name, selector, options) {
      var self = this;
      document.querySelectorAll(selector).forEach(function (el) {
        self.mount(name, el, options);
      });
    },

    // Viewport tier — mount when element enters the viewport (IntersectionObserver)
    lazyMount: function (name, selector, options) {
      var self = this;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          self.mount(name, entry.target, options);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '120px' });

      document.querySelectorAll(selector).forEach(function (el) {
        observer.observe(el);
      });
    },

    // Interaction tier — mount on first pointer/focus toward element
    deferMount: function (name, selector, options, triggerEvents) {
      var self = this;
      triggerEvents = triggerEvents || ['pointerenter', 'focusin'];

      var handler = function (e) {
        var el = e.target.closest(selector);
        if (!el) return;
        triggerEvents.forEach(function (ev) {
          document.removeEventListener(ev, handler, true);
        });
        self.mount(name, el, options);
      };

      triggerEvents.forEach(function (ev) {
        document.addEventListener(ev, handler, { capture: true, passive: true });
      });
    }
  };

  // ── Expose globals ────────────────────────────────────────────────────────────
  window.LakiEvents = LakiEvents;
  window.LakiComponents = LakiComponents;
})();
